import { render, staticRenderFns } from "./SendActivityCoinDialog.vue?vue&type=template&id=b15215be&scoped=true&"
import script from "./SendActivityCoinDialog.vue?vue&type=script&lang=js&"
export * from "./SendActivityCoinDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b15215be",
  null
  
)

export default component.exports